import MainClass from '@/src/module/comm_main';
import {tab_event as TabEvt} from '@/src/module/tab-event';
var container= jhc.commElem.container;
MainClass.init(container);
MainClass.run();

const tabElems= document.querySelectorAll('[data-tab-name]');
TabEvt(tabElems);
